"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppModal = void 0;
var AppModal_1 = require("./AppModal");
Object.defineProperty(exports, "AppModal", { enumerable: true, get: function () { return __importDefault(AppModal_1).default; } });
